import styled from 'styled-components';

import PageContent from 'components/PageContent';
import { appSideSpacing } from 'styles/spacings';
import { red, brandColors, grey200 } from 'styles/colors';
import { NavLink } from 'react-router-dom';

export const SettingsContent = PageContent.extend`
	background-color: #f8f8f8;
	padding: 32px ${appSideSpacing};
`;

export const Form = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 100%;
`;

export const Alert = styled.p`
	color: ${red};
	margin-right: 10px;
`;

export const StyledNavLink = styled(NavLink)`
	display: inline-block;
	padding: 15px 8px;
	margin-right: 5px;
	position: relative;
	text-transform: uppercase;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 13px;

	&.active {
		color: ${brandColors.green};
		border-bottom: 2px solid ${brandColors.green};
	}

	${({ disabled }) =>
		disabled &&
		`
			color: ${grey200};
	`};
`;

export const PageToolbarRightBlock = styled.div`
	align-items: center;
	display: flex;
`;

export const CenterSectionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const BuildVersion = styled.div`
	font-size: 15px;
	margin-top: 32px;
	text-align: center;
`;
